export const GRAMAX_EDITOR_URL = "https://app.gram.ax";

export const DOC_ROOT_FILENAME = ".doc-root.yaml";
export const DOC_ROOT_REGEXP = /.(doc-)?root.ya?ml/;

export const NEW_CATALOG_NAME = "new-catalog";

export const CATEGORY_ROOT_FILENAME = "_index.md";
export const CATEGORY_ROOT_REGEXP = /(_index_\w\w\.md$|_index\.md$)/;

export const NEW_ARTICLE_FILENAME = "new-article";
export const NEW_ARTICLE_REGEX = /^new[-|_]article/;

export const UNIQUE_NAME_SEPARATOR = "-";
export const UNIQUE_NAME_START_IDX = 2;

export const LEFT_NAV_CLASS = "left-navigation-layout";
export const RIGHT_NAV_CLASS = "right-nav-layout";
